import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { message } from "antd";
import { i18n } from "i18n";
import { StatusNotification } from "types";
import { SubGameType } from "types/game";

export const handleLoginGame = async (
  _dataLogin: SubGameType,
  _username: string,
  _dispatch: Dispatch<AnyAction>,
  openNotification?: (status: StatusNotification, message: string) => void
) => {
  const currentLang = (
    i18n.language ||
    localStorage.getItem("i18nLng") ||
    "tr"
  ).toLowerCase();

  let msg = "Coming soon!";

  if (currentLang.startsWith("tr")) {
    msg = "Çok yakında!";
  } else if (currentLang.startsWith("zh")) {
    msg = "即將推出！";
  } else if (currentLang.startsWith("vi")) {
    msg = "Trò chơi sắp ra mắt!";
  } else {
    msg = "Coming soon!";
  }

  if (openNotification) {
    openNotification("info", msg);
  } else {
    message.info(msg);
  }
};
